import * as React from 'react'
const SvgIcoScamark = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    id='ICO_Scamark_N_svg__Calque_1'
    viewBox='0 0 200 200'
    {...props}
  >
    <defs>
      <style>
        {
          '.ICO_Scamark_N_svg__st1,.ICO_Scamark_N_svg__st2{fill:#7984ba}.ICO_Scamark_N_svg__st1,.ICO_Scamark_N_svg__st3{fill-rule:evenodd}.ICO_Scamark_N_svg__st4{display:none}'
        }
      </style>
    </defs>
    <g id='ICO_Scamark_N_svg__Calque_9'>
      <circle
        cx={100}
        cy={100}
        r={28.77}
        style={{
          fill: 'none',
          stroke: '#000',
          strokeMiterlimit: 10,
        }}
      />
      <path d='M110.67 92.49c-2.63.13-4.44 0-6.67-.08-1.63-.07-5.89-5.24-6.96-1.36s9.15 6.1 11.77 7.68c12.69 7.65-1.97 24.89-16.14 18-3.03-1.47-5.15-4.23-6.24-7.87-.17-.58-.19-1.3.91-1.41 1.52-.15 4.03-.5 6.77-.5s4.18 3.94 6.99 3.03c1.61-.52 2.28-3.62.92-4.66-3.06-2.36-12.68-3.46-14.7-8.26-6.64-15.82 22.77-22.14 24.47-5.64.05.91-.75 1.07-1.13 1.09Z' />
    </g>
  </svg>
)
export default SvgIcoScamark

